import React, { Fragment, useEffect } from "react";
import { ThemeProvider } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import "../public/styles.css";
import Head from "next/head";
import { Provider } from "react-redux";
import { onpreoTheme } from "@onpreo/components/src/theme";
import { initStore } from "../src/store";
import { Snacker } from "@onpreo/slices/src/snackbar";

export default function OnpreoApp({ Component, pageProps: { session, ...pageProps } }) {
    const store = initStore(pageProps.initialReduxState);

    useEffect(() => {
        // Remove the server-side injected CSS.
        const jssStyles = document.querySelector("#jss-server-side");
        if (jssStyles && jssStyles.parentElement) jssStyles.parentElement.removeChild(jssStyles);
    }, []);

    return (
        <Fragment>
            <Head>
                <title>onpreo</title>
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            </Head>
            <ThemeProvider theme={onpreoTheme}>
                <Provider store={store}>
                    <Snacker />
                    <CssBaseline />
                    <Component {...pageProps} />
                </Provider>
            </ThemeProvider>
        </Fragment>
    );
}
